import subMonthAdjustRecord from './subMonthAdjustRecord'
export default {
  components: { subMonthAdjustRecord },
  data() {
    return {
      subMonthAdjustRecordVisible: false
    }
  },
  methods: {
    showsubMonthAdjustRecord(row) {
      this.rowData = row;
      this.subMonthAdjustRecordVisible = true;
    }
  }
}